module.exports = __webpack_public_path__ + "static/img/yk4200.eaacab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk4200.png
// module id = dERj
// module chunks = 1